/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {SplitButtonElement} from './split-button-element.js';

declare global {
  interface HTMLElementTagNameMap {
    /** A Material Design component. */
    'md-gb-split-button': SplitButtonElement;
  }
}

customElements.define('md-gb-split-button', SplitButtonElement);
